export default "__VITE_ASSET__354828ef__"